let assign = require('object-assign');
let Storage = require('./storage');

function TJSON(json) {
    this.storage = new Storage(json);
    this.state = {};
}

TJSON.prototype.i18n = require('./i18n');

TJSON.prototype.lang = function(language) {
    if (typeof language !== 'string') { throw new Error('Language must be a string, not a ' + language) }
    return this.clone({ language: language });
};

TJSON.prototype.keyset = function(keyset) {
    if (typeof keyset !== 'string') { throw new Error('Keyset must be a string, not a ' + keyset) }
    return this.clone({ keyset: keyset });
};

TJSON.prototype.get = function(key, number) {
    number = Number(number) || 0;

    let translation = this.storage.key(this.state.language, this.state.keyset, key);

    if (!translation) { return undefined }

    if (translation.isPlural && this.i18n[this.state.language] && this.i18n[this.state.language].plural) {
        return this.i18n[this.state.language].plural(
            number,
            translation.one,
            translation.some,
            translation.many,
            translation.none);
    }

    return translation.form;
};

TJSON.prototype.clone = function(withProps) {
    let tjson = new TJSON();
    tjson.storage = this.storage;
    tjson.state = assign({}, this.state, withProps);
    return tjson;
};

TJSON.prototype.merge = function(json) {
    this.storage.merge(json);
    return this;
};

TJSON.prototype.key = function(key, keyset, lang) {
    lang = lang || this.state.language;
    keyset = keyset || this.state.keyset;
    return this.storage.key(lang, keyset, key);
};

TJSON.prototype.keys = function(keyset, lang) {
    lang = lang || this.state.language;
    keyset = keyset || this.state.keyset;
    return this.storage.keys(lang, keyset);
};

TJSON.prototype.keysets = function(lang) {
    lang = lang || this.state.language;
    return this.storage.keysets(lang);
};

TJSON.prototype.languages = function() {
    return this.storage.languages();
};

module.exports = TJSON;
